/**
 * User group names the backend reserves and no organization group may take.
 *
 * Mirrors the backend's `ReservedOpsiumUserGroupName`. Because these names cannot be claimed
 * by a user-created group, matching on them is reliable — which matters on endpoints that
 * return group names without any accompanying flags (e.g. `GET /api/team/user-groups`).
 *
 * This is not a wire-format DTO: group names are plain strings on the wire, and the enum
 * exists only so the reserved literals live in one place.
 */
export enum ReservedUserGroupName {
  /** Protected group: its policies cannot be modified, and it cannot be renamed or deleted. */
  SUPER_ADMIN = 'Super Admin',
}
